<template>
  <div v-if="tags.length" :class="categoryClass" class="tags-list mb-8">
    <div class="more">{{ $t('taglist.more') }}</div>
    <div class="bar">
      <ul>
        <li v-for="tag in tags" :key="tag.slug">
          <nuxt-link :to="`/tags/${tag.slug}`">{{
            tag.name | entityDecode
          }}</nuxt-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tags: {
      type: Array,
      required: true,
    },
    categoryClass: {
      type: String,
      required: true,
    },
  },
}
</script>

<style>
@import '~components/content/widgets/TagsList.css';
</style>
